/**
 * `Layout` props for any page of a brand's public site, worked out from that brand's content (content/*.js).
 *
 * The homepage, the quote page and the legal pages all did this by hand. The nav's "Help" item is not a nav link:
 * it becomes the header's help button. `hiddenNavLabels` drops items a particular page doesn't show (the homepage
 * leaves out links to itself).
 */
export default function brandLayoutProps(content, hiddenNavLabels = []) {
    return {
        nav: content.nav.filter((item) => item.label !== 'Help' && !hiddenNavLabels.includes(item.label)),
        helpHref: content.nav.find((item) => item.label === 'Help')?.href,
        productName: content.productName,
        homeHref: content.links?.home,
        registerHref: content.links?.register,
        footerLinks: content.footerLinks,
        logo: content.logo,
        theme: content.theme,
        // Undefined leaves Layout's default, Cambridge University Press.
        copyright: content.copyright,
    };
}
